<template>
	<div>
		<az-toolbar>
			<template #actions><strong class="primary--text">Relatório Personalizado</strong></template>
		</az-toolbar>
		<az-container>
			<hal-gerador-relatorios formato-lista="Lista" :produto-id="idProduto"></hal-gerador-relatorios>
		</az-container>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'relatorios-personalizados',
	computed: {
		...mapState({
			idProduto: (state) => state.loki.product.id,
		}),
	},
}
</script>
<style scoped lang="stylus"></style>
